import script from "./TvResultsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TvResultsView.vue?vue&type=script&setup=true&lang=js"

import "./TvResultsView.vue?vue&type=style&index=0&id=84079678&lang=css"
import "./TvResultsView.vue?vue&type=style&index=1&id=84079678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84079678"]])

export default __exports__